import { API_OPTIONS } from "../utils/constant";
import { useDispatch,useSelector } from "react-redux";
import { addUpcomingMovies } from "../utils/movieSlice";
import { useEffect } from "react";

const useUpcomingMovies = () => {
	const dispatch = useDispatch();
	const Upcoming=useSelector((store)=>store.movies.upcomingmovies)
	const upcomingmovies = async () => {
		const data = await fetch(
			"https://api.themoviedb.org/3/movie/upcoming?page=1",
			API_OPTIONS
		);
		const json = await data.json();
		dispatch(addUpcomingMovies(json.results));
	};

	useEffect(() => {
		upcomingmovies();
	}, []);
};

export default useUpcomingMovies;
